import { WorkflowType } from '@communities/content-management/domain';
import type { PresenceConfig } from '@core/components/LabelSelector';

/**
 * Presence-based configuration for custom and moderation labels.
 * Used across CustomLabelsStep, ImageLabelsStep (moderation), and ReviewStep.
 */
export const PRESENCE_CONFIG: PresenceConfig = {
  mode: 'presence',
};

/**
 * Copy strings for each workflow type in the policy dialog.
 */
export const POLICY_COPY: Record<
  WorkflowType.CLASSIFICATION | WorkflowType.MODERATION,
  {
    toggleDescription: string;
    enabledAnnouncement: string;
    disabledAnnouncement: string;
    reviewStatusEnabled: string;
    reviewStatusDisabled: string;
  }
> = {
  [WorkflowType.CLASSIFICATION]: {
    toggleDescription:
      'When enabled, this policy will actively monitor and flag content according to the configured rules. When disabled, the policy will not be applied to any content.',
    enabledAnnouncement: 'Policy is now enabled and will actively monitor content',
    disabledAnnouncement: 'Policy is now disabled and will not monitor content',
    reviewStatusEnabled: 'This policy will actively monitor content',
    reviewStatusDisabled: 'This policy will not be applied to content',
  },
  [WorkflowType.MODERATION]: {
    toggleDescription:
      'When enabled, this policy will actively monitor moderated cases and flag content according to the configured rules. When disabled, the policy will not be applied to any cases.',
    enabledAnnouncement: 'Policy is now enabled and will be active for moderated cases',
    disabledAnnouncement: 'Policy is now disabled and will not be active for moderated cases',
    reviewStatusEnabled: 'This policy will be active for moderated cases',
    reviewStatusDisabled: 'This policy will not be active for moderated cases',
  },
};
